export default __webpack_public_path__ + "static/media/expitem8.af532834.png";